export default __webpack_public_path__ + "static/media/img-b-result-distance-be_fr@2x.dedb35bf.jpg";